import { MediaType } from '../../../commonTypes';
import {
    AudioProperties, ImageProperties, MediaProperties, VideoProperties
} from '../../duck/types';

export const isVideo = (_mediaProps: MediaProperties,mediaType: MediaType): _mediaProps is VideoProperties => mediaType === MediaType.Video;
export const isImage = (_mediaProps: MediaProperties,mediaType: MediaType): _mediaProps is ImageProperties => mediaType === MediaType.Image;
export const isAudio = (_mediaProps: MediaProperties,mediaType: MediaType): _mediaProps is ImageProperties => mediaType === MediaType.Audio;
